exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-o-mne-tsx": () => import("./../../../src/pages/o-mne.tsx" /* webpackChunkName: "component---src-pages-o-mne-tsx" */)
}

